import Vue from 'vue'
import _ from 'lodash'
import countryList from 'country-list'
import moment from 'moment'
import marked from 'marked'
import qs from 'querystring'

const countries = countryList()

Vue.filter('pad', (value, n=2) => {
  return `${value}`.padStart(n, '0')
})

Vue.filter('country', code => {
  const country = countries.getName(code)

  if(code === 'kr') {
    return 'Republic of Korea'
  } else {
    return country
  }
})

Vue.filter('numDate', num => {
  const format = 'DD.MM.YYYY'
  const week = moment().year(2018).startOf('year').week(num)
  const weekEnd = week.clone().add(7, 'days')
  
  return `${week.format(format)} – ${weekEnd.format(format)}`
})

Vue.filter('markdown', string => {
  return string && marked(string)
})

Vue.filter('imgix', (src, options = {}) => {
  if(typeof src === 'string') {
    return `https://wsrv.nl?${qs.stringify({url: src, ...options})}`
  }
  return src
})


// WEBPACK FOOTER //
// ./src/filters.js